import React from 'react';
import Alert, { AlertProps } from './Alert';

export type { AlertProps } from './Alert';

export interface DetailedAlertProps extends AlertProps {
  text: string;
  textOnClick?: string;
  onClick?: () => void;
}

export const ErrorAlert = (props: DetailedAlertProps) => {
  const { text, textOnClick, onClick, ...otherProps } = props;
  const lines = text.split('\n');
  const isMultiLine = lines.length > 1;

  return (
    <Alert {...otherProps} type="error">
      <div
        style={
          isMultiLine
            ? { textAlign: 'left', display: 'inline-block' }
            : undefined
        }
      >
        {lines.map((line, index) => (
          <p key={index} style={{ margin: '4px 0' }}>
            {line}
            {index === lines.length - 1 &&
              textOnClick != undefined &&
              onClick != undefined && (
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    onClick!();
                  }}
                >
                  {textOnClick}
                </a>
              )}
          </p>
        ))}
      </div>
    </Alert>
  );
};

export const SuccessAlert = (props: DetailedAlertProps) => {
  const { text, ...otherProps } = props;

  return (
    <Alert {...otherProps} type="success">
      <p>{text}</p>
    </Alert>
  );
};

export default Alert;
